<template>
  <div id="toolbox" class="home">
    <el-container>
      <div style="margin:80px 100px;width:100%;">
        <div class="condition">
          <el-row class="condition-row">
            <el-col :span="3">
              <span class="condition-checked condition-head">分类:</span>                                          
            </el-col>
            <el-col :span="21">
              <span :class="{'condition-checked':true,'tag':true,'active':tagId == 0}"  @click="handleTags(0)">全部</span>
              <span  :class="{'condition-checked':true,'tag':true,'active':tagId == item.id}"  @click="handleTags(item.id)" v-for="item in categorys" :key="item.id">{{item.name}}</span>
            </el-col>
          </el-row>
        </div>
        <div style="margin-top:20px;">
          <div class="condition">
            <div class="results" v-show="list.length == 0">              
              <el-row>
                <el-col :span="24">
                  <div class="empty">暂无数据</div>
                </el-col>
              </el-row>          
            </div>
            <div  class="list-box"  v-loading="loading">
              <el-row :gutter="40">
                <el-col :span="6" v-for="item in list" :key="item.id">
                  <div class="list-item">
                    <el-row>
                      <el-col :span="24">
                        <div class="biaoti">{{ item.title }}</div>
                        <div class="miaoshu">{{ item.subtitle}}</div>
                        <el-row type="flex" align="middle">
                          <el-col :span="21">
                            <div :class="{'mianfei':!item.free,'fufei': item.free}">{{ item.free==0?"免费":"付费"}}</div>
                          </el-col>
                          <el-col :span="3">
                            <img src="../assets/images/download.png" alt="" class="icon" @click="xiazai(item.id)">
                          </el-col>
                        </el-row>                        
                      </el-col>                      
                    </el-row>
                  </div>
                </el-col>                
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </el-container>
  </div>
</template>
<script>
import { fetchGet,fetchPost } from '../utils/http';
import helpers from '../helper';
export default {
  name:'toolbox',
  data(){
    return {
      tagId:0,
      loading:false,
      list:[],
      categorys:[
        {id:1,name:'人力资源规划'},
        {id:2,name:'招聘与配置'},
        {id:3,name:'培训和开发'},
        {id:4,name:'绩效管理'},
        {id:5,name:'薪酬福利管理'},
        {id:6,name:'员工关系'},
      ]
    }
  },
  mounted(){
    this.init()
  },
  methods:{
    init(){
      this.getList()
    },
    handleTags(id){
      this.tagId = id      
      this.getList(id)
    },
    xiazai(id){      
      this.download(id)      
    },
    download(id){
      this.loading = true;
      let _this = this;
      fetchPost('/api/home/api/downLoadToolFile',{
        id:id
      }).then((res)=>{
        this.loading = false;
        if(res.data.code === 10001){
          _this.$message.error(res.data.msg);
          _this.$router.push('/login');
        }        
        if(res.data.code === 0){          
          this.open(res.data.msg)
        }
        if(res.data.code === 1){
          // var a = document.createElement('a');
          // a.href=res.data.data;
          // a.target='_blank';          
          // a.click();
          window.location.href =  res.data.data
        }
      });
    },
    open(msg) {
      this.$confirm( msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({name:"member-center",params:{activeIndex:"package"}})
      }).catch(() => {
        
      });
    },
    getList(id){
      let category = id || 0      
      console.log(category)
      this.loading = true;
      let _this = this;
      
      this.$http.post(
        helpers.BASE_URL + '/api/home/index/getToolList',
        {category:this.tagId}
      ).then(function(response){
        //console.log(response.data);
        _this.loading = false;
        if(response.data.code === 1 ){
          _this.list = response.data.data          
        }else{
          _this.loading = false;
          return _this.$message.error(response.data.msg);
        }
      })
      .catch(function (error) {
         _this.loading = false;
          _this.$message.error('网络错误，请刷新重试')
      });      
    }
  }
}
</script>
<style scoped>
.home{
  background-color: #f4f4f4;
  width: 100%;
}
.condition{
  background-color: #ffffff;  
  padding: 20px;
  border-radius: 10px;
}
.condition-head{
  font-size: 14px;
  margin-right: 40px;
  display: inline-block;
  width: 80px;
  text-align: right;
}
.condition-checked{
  margin: 5px 6px 0 0;
  padding: 2px 5px ;
  float: left;
  word-wrap:break-word;
}
.condition-row{
  margin-bottom: 4px;
}
.tag{
  font-size: 14px;
  color: #939393;
  cursor: pointer;
  margin-right: 20px;
}
.tag:hover{
  background-color: #0bc8f4;
  color: #ffffff;
  border-radius: 4px;
}
.active{
  background-color: #0bc8f4;
  color: #ffffff;
  border-radius: 4px;
}
.results{
  margin: 0 100px 20px 100px;
  background-color: #ffffff;
  padding: 30px 60px;
  border-radius: 10px;
}
.empty{
  text-align: center;
  min-height: 200px;
  margin-top: 100px;  
  font-size: 14px;
  color: #888;
}
.list-box{
  margin: 0 40px;
  padding-top: 40px;
}
.list-item{
  padding: 20px;
  margin-bottom: 40px;
  border: 1px solid #FFEDE6;
}
.biaoti, .miaoshu, .shijian{
  margin-bottom: 10px;
}
.biaoti{  
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 36px;
}
.miaoshu{
  font-size: 12px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 26px;
}
.mianfei{
  font-size: 12px;
  color: #888;
  padding: 4px 0;
}
.fufei{
  font-size: 12px;
  color: #ff0000;
  padding: 4px 0;
}
.icon{
  width: 100%;
  cursor: pointer;
}
</style>
